import type {Thread} from '@github-ui/diff-lines/conversation-types'

export function threadLabel(thread: Thread) {
  const range = thread.originalPositioning
  const path = range?.path || 'file'
  const startLine = range?.startLine
  const line = range?.endLine
  if (!line) return path
  return startLine && startLine !== line ? `${path}, lines ${startLine} to ${line}` : `${path}, line ${line}`
}
